const ACTIONS = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_CONFIRM',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'TRANSPORTS_VIEW',
  'TRANSPORTS_CREATE',
  'TRANSPORTS_EDIT',
  'DRIVERS_VIEW',
  'DRIVERS_CREATE',
  'DRIVERS_EDIT',
  'DRIVERS_REASSIGN',
  'USERADMINS_VIEW',
  'USERADMINS_CREATE',
  'USERADMINS_EDIT',
  'INVOICE_VIEW',
  'INVOICE_CREATE',
  'INVOICE_UPDATE',
  'INVOICE_PRINT',
  'INVOICE_PROFORMA_EMAIL',
  'INVOICE_PROFORMA_DOWNLOAD_CSV',
  'ORDERS_CALCULATE_UNIT',
  'ORDERS_UPDATE_MAIN_PRICE',
  'ORDERS_UPDATE_MAIN_PRICE_UNIT',
  'ORDERS_UPDATE_ADDITIONAL_PRICE',
  'INVOICEDATA_VIEW',
  'INVOICEDATA_EDIT',
  'REPORTS_FINANCE',
  'REPORTS_OPERATIONAL'
]

const TRANSPORTER_SUPER_ADMIN = [
  ...ACTIONS
]

const TRANSPORTER_ADMIN = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_CONFIRM',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'ORDER_REPORTS_RESOLVE',
  'SCHEDULE_VIEW',
  'TRANSPORTS_VIEW',
  'DRIVERS_VIEW',
  'DRIVERS_CREATE',
  'DRIVERS_EDIT',
  'TRANSPORTS_VIEW',
  'TRANSPORTS_CREATE',
  'TRANSPORTS_EDIT',
  'REPORTS_FINANCE',
  'REPORTS_OPERATIONAL'
]

const TRANSPORTER_ADMIN_FAA = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'INVOICE_VIEW',
  'INVOICE_CREATE',
  'INVOICE_UPDATE',
  'INVOICE_PRINT',
  'INVOICE_PROFORMA_EMAIL',
  'INVOICE_PROFORMA_DOWNLOAD_CSV',
  'INVOICEDATA_VIEW',
  'INVOICEDATA_EDIT',
  'ORDERS_CALCULATE_UNIT',
  'ORDERS_UPDATE_MAIN_PRICE',
  'ORDERS_UPDATE_MAIN_PRICE_UNIT',
  'ORDERS_UPDATE_ADDITIONAL_PRICE',
  'ORDERS_DETAIL_VIEW',
  'SCHEDULE_VIEW',
  'REPORTS_FINANCE',
  'REPORTS_OPERATIONAL'
]

const TRANSPORTER_MONITORING = [
  'WEB_ACCESS',
  'ORDERS_SUMMARY_VIEW',
  'ORDERS_VIEW',
  'ORDERS_DETAIL_VIEW',
  'ORDER_REPORTS_VIEW',
  'SCHEDULE_VIEW',
  'REPORTS_FINANCE',
  'REPORTS_OPERATIONAL'
]

export default {
  TRANSPORTER_SUPER_ADMIN,
  TRANSPORTER_ADMIN,
  TRANSPORTER_ADMIN_FAA,
  TRANSPORTER_MONITORING
}
